/* ==========================================================
   CRIATIVO SOL UI KIT® v1.0
   F001 — Header Premium™
   Interações do Header
   ========================================================== */

(() => {
  const headers = document.querySelectorAll('[data-cs-header]');

  headers.forEach((header) => {
    const toggle = header.querySelector('[data-cs-menu-toggle]');
    const menu = header.querySelector('[data-cs-mobile-menu]');

    /*
     * Estado do Header durante o scroll
     * Adiciona a classe .is-scrolled após 24px
     */
    const updateScrollState = () => {
      const scrolled = window.scrollY > 24;

      header.classList.toggle('is-scrolled', scrolled);
    };

    updateScrollState();

    window.addEventListener(
      'scroll',
      updateScrollState,
      { passive: true }
    );

    /*
     * Se não existir menu mobile nesta instância,
     * termina aqui sem gerar erros.
     */
    if (!toggle || !menu) return;

    /*
     * Abre / fecha menu mobile
     */
    const setMenu = (open) => {
      toggle.setAttribute(
        'aria-expanded',
        String(open)
      );

      toggle.setAttribute(
        'aria-label',
        open ? 'Fechar menu' : 'Abrir menu'
      );

      menu.setAttribute(
        'aria-hidden',
        String(!open)
      );

      menu.classList.toggle(
        'is-open',
        open
      );

      document.body.classList.toggle(
        'cs-menu-open',
        open
      );
    };

    /*
     * Clique no botão hamburger
     */
    toggle.addEventListener('click', () => {
      const isOpen =
        toggle.getAttribute('aria-expanded') === 'true';

      setMenu(!isOpen);
    });

    /*
     * Fecha o menu quando:
     * - o utilizador clica no fundo
     * - seleciona um link
     */
    menu.addEventListener('click', (event) => {
      if (
        event.target === menu ||
        event.target.closest('a')
      ) {
        setMenu(false);
      }
    });

    /*
     * Permite fechar o menu com ESC
     * para melhorar acessibilidade
     */
    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        toggle.getAttribute('aria-expanded') === 'true'
      ) {
        setMenu(false);

        toggle.focus();
      }
    });
  });
})();